import Wprr from "wprr";
import React from "react";


export default class TextAndImage extends Wprr.BaseObject {
	
	_construct() {
		super._construct();
	}

	_renderMainElement() {
		
		let title = this.getFirstInput("title", Wprr.sourceReference("blockData", "title"));
		let text = this.getFirstInput("text", Wprr.sourceReference("blockData", "text"));
		let excerpt = this.getFirstInput("excerpt", Wprr.sourceReference("blockData", "excerpt"));
		let image = this.getFirstInput(Wprr.sourceReference("blockData", "image.url"));
		let textAfterButton = this.getFirstInput("textAfterButton", Wprr.sourceReference("blockData", "textAfterButton"));
		
		let linkUrl = this.getFirstInput(Wprr.sourceReference("blockData", "link.url"));
		let linkLabel = this.getFirstInput(Wprr.sourceReference("blockData", "link.label"));

		let imageOnRight = this.getFirstInputWithDefault(Wprr.sourceReference("blockData", "imageOnRight"), false);
		
		let mobileLayout = <div className="centered-site">
			<Wprr.ElementSize>
				<Wprr.Adjust adjust={[Wprr.adjusts.ratio(Wprr.sourceProp("width"), 0.75, "height"), Wprr.adjusts.styleFromHeight()]}>
					<div>
						<Wprr.Image className="background-cover full-size" src={image} />
					</div>
				</Wprr.Adjust>
			</Wprr.ElementSize>
			<div className="spacing medium" />
			<div className="text-and-image text-and-image-text-box-mobile-padding">
				<h2 className="no-margins text-uppercase text-and-image-title">
					{Wprr.text(title)}
				</h2>
				<Wprr.HasData check={excerpt}>
					<div className="spacing medium" />
					<div className="text-and-image-excerpt wp-rich-text-formatting">
						{Wprr.text(excerpt, "html")}
					</div>
				</Wprr.HasData>
				<Wprr.HasData check={text}>
					<div className="spacing medium" />
					<div className="text-and-image-text wp-rich-text-formatting">
						{Wprr.text(text, "html")}
					</div>
				</Wprr.HasData>
				
				<Wprr.HasData check={linkUrl && linkLabel}>
					<div className="spacing small" />
					<Wprr.FlexRow>
						<Wprr.Link href={linkUrl} className="custom-styled-link">
							<Wprr.layout.interaction.Button className="standard-button standard-button-hover standard-button-padding cursor-pointer" text={linkLabel} />
						</Wprr.Link>
					</Wprr.FlexRow>
				</Wprr.HasData>
				<Wprr.HasData check={textAfterButton}>
					<div className="spacing medium" />
					<div className="text-and-image-text-after-button wp-rich-text-formatting">
						{Wprr.text(textAfterButton, "html")}
					</div>
				</Wprr.HasData>
			</div>
		</div>;

		let desktopTextElement = <div className="text-and-image text-and-image-text-box-padding">
			<h2 className="no-margins text-uppercase text-and-image-title">
				{Wprr.text(title)}
			</h2>
			<Wprr.HasData check={excerpt}>
				<div className="spacing medium" />
				<div className="text-and-image-excerpt wp-rich-text-formatting">
					{Wprr.text(excerpt, "html")}
				</div>
			</Wprr.HasData>
			<Wprr.HasData check={text}>
				<div className="spacing medium" />
				<div className="text-and-image-text wp-rich-text-formatting">
					{Wprr.text(text, "html")}
				</div>
			</Wprr.HasData>
			<Wprr.HasData check={linkUrl && linkLabel}>
				<div className="spacing standard" />
				<Wprr.FlexRow>
					<Wprr.Link href={linkUrl} className="custom-styled-link">
						<Wprr.layout.interaction.Button className="standard-button standard-button-hover standard-button-padding cursor-pointer" text={linkLabel} />
					</Wprr.Link>
				</Wprr.FlexRow>
			</Wprr.HasData>
			<Wprr.HasData check={textAfterButton}>
				<div className="spacing medium" />
				<div className="text-and-image-text-after-button wp-rich-text-formatting">
					{Wprr.text(textAfterButton, "html")}
				</div>
			</Wprr.HasData>
		</div>;
		
		
		let desktopLayout = <div className="centered-site">
			<Wprr.FlexRow className="big-item-spacing" itemClasses="width-50,width-50">
				<Wprr.Image className="background-cover full-size" src={image} />
				{desktopTextElement}
			</Wprr.FlexRow>
		</div>;

		if(imageOnRight) {
			desktopLayout = <div className="centered-site">
				<Wprr.FlexRow className="big-item-spacing" itemClasses="width-50,width-50">
					{desktopTextElement}
					<Wprr.Image className="background-cover full-size" src={image} />
				</Wprr.FlexRow>
			</div>;
		}
		
		let responsiveLayout = Wprr.creators.responsiveTemplate(mobileLayout);
		responsiveLayout.addResponsiveTemplate(desktopLayout, 860);
		
		return <React.Fragment>
			{responsiveLayout.getReactElements()}
		</React.Fragment>;
	}
	
	static getWpAdminEditor() {
		console.log("getWpAdminEditor");
		
		let dataSettings = {
			
		};
		
		return <Wprr.layout.admin.WpBlockEditor dataSettings={dataSettings}>
			<div>
				<Wprr.layout.form.LabelledArea label="Image">
					<Wprr.wp.blocks.editor.ImageSelection valueName="image" />
				</Wprr.layout.form.LabelledArea>
				<Wprr.layout.form.LabelledArea label="Mobile image">
					<Wprr.wp.blocks.editor.ImageSelection valueName="mobileImage" />
				</Wprr.layout.form.LabelledArea>
				<Wprr.layout.form.LabelledArea label="Title">
					<Wprr.FormField value={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage", "title")} />
				</Wprr.layout.form.LabelledArea>
				<Wprr.layout.form.LabelledArea label="Excerpt">
					<Wprr.wp.blocks.editor.RichTextEditor valueName="excerpt" externalStorage={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage")} />
				</Wprr.layout.form.LabelledArea>
				<Wprr.layout.form.LabelledArea label="Text">
					<Wprr.wp.blocks.editor.RichTextEditor valueName="text" externalStorage={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage")} />
				</Wprr.layout.form.LabelledArea>
				<Wprr.layout.form.LabelledArea label="Link">
					<Wprr.wp.blocks.editor.Link valueName="link" externalStorage={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage")} />
				</Wprr.layout.form.LabelledArea>
				<Wprr.layout.form.LabelledArea label="Image on right">
					<Wprr.Checkbox checked={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage", "imageOnRight")} />
				</Wprr.layout.form.LabelledArea>
				<Wprr.layout.form.LabelledArea label="Text after button">
					<Wprr.wp.blocks.editor.RichTextEditor valueName="textAfterButton" externalStorage={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage")} />
				</Wprr.layout.form.LabelledArea>
			</div>
		</Wprr.layout.admin.WpBlockEditor>;
	}
}